export function parsedValue(value, src) {
    return { value, src };
}
//# sourceMappingURL=ParsedValue.js.map